module.exports = __webpack_public_path__ + "img/question-mark-secondary.png";